// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"0c765dfc","736":"f63fc39f","752":"baeaa1f2"}[chunkId] + ".chunk.css";
};